<template>
    <v-sheet class="ma-4 defaultCard" color="bgtopology">
        <SingleChart v-if="rxbytes.length !== 0" :name="'rxbytes'" :first-array="rxbytes" :title="'RX (MBytes)'" :color="COLOR.single"/>
        <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
        </v-sheet>
    </v-sheet>
    <v-sheet class="ma-4 defaultCard" color="bgtopology">
        <SingleChart v-if="txbytes.length !== 0" :name="'txbytes'" :first-array="txbytes" :title="'TX (MBytes)'" :color="COLOR.single"/>
        <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
        </v-sheet>
    </v-sheet>


</template>

<script setup lang="ts">
import { COLOR }           from '@/constants/colors';
import Prog_circular        from '@/components/PrincipalComponents/Prog_circular.vue';
import SingleChart          from '@/components/SmartLink/charts/SingleChart.vue';
defineProps({
    rxbytes   : { required:true, type:Array },
    txbytes   : { required:true, type:Array },
})

</script>
